import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import Logo from "@images/Symbol_White.svg";
import { motion, AnimatePresence } from "framer-motion";
import { v4 as uuidv4 } from "uuid";

export const DummyEditorPage = () => {
  const [bars, setBars] = useState<any>([]);

  useEffect(() => {
    createRandomBars();
  }, []);

  const listItem = {
    hidden: { opacity: 0, width: 0 },
    show: { opacity: 1, width: "inherit" },
  };

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const createRandomBars = () => {
    const newBars: any = [];
    for (let i = 0; i < 15; i++) {
      newBars.push({
        id: i,
        value: Math.floor(Math.random() * 100),
        color: `hsl(${Math.floor(Math.random() * 360)}, 100%, 50%)`,
        width: Math.floor(Math.random() * 100),
      });
    }
    setBars(newBars);
  };
  return (
    <div className="h-screen  w-full relative bg-gray-50">
      <div className="flex flex-row justify-between  px-20 py-10">
        <Link href="/">
          <Image
            className="block h-8  w-auto cursor-pointer lg:absolute lg:top-0 lg:left-0 lg:ml-4 lg:mt-2 p-2"
            src={Logo}
            alt="Moonbeam"
          />
        </Link>
        <div className="flex flex-row overflow-hidden rounded-xl">
          {[...new Array(5).fill(1)].map((_, i) => (
            <div key={"first" + i} className="h-10 w-10 bg-gray-200" />
          ))}
        </div>
        <div className="flex flex-row overflow-hidden rounded-xl">
          {[...new Array(5).fill(1)].map((_, i) => (
            <div key={"second" + i} className="h-10 w-10 bg-gray-200" />
          ))}
        </div>
        <div className="flex flex-row overflow-hidden rounded-xl">
          {[...new Array(5).fill(1)].map((_, i) => (
            <div key={"third" + i} className="h-10 w-10 bg-gray-200" />
          ))}
        </div>
        <div className="flex flex-row overflow-hidden rounded-xl">
          {[...new Array(5).fill(1)].map((_, i) => (
            <div key={"fourth" + i} className="h-10 w-10 bg-gray-200" />
          ))}
        </div>
        <div className="flex flex-row overflow-hidden rounded-xl">
          {[...new Array(5).fill(1)].map((_, i) => (
            <div key={"fifth" + i} className="h-10 w-10 bg-gray-200" />
          ))}
        </div>
      </div>
      <div className="max-w-7xl flex space-x-10 mx-auto w-full h-[80%]">
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className="h-full bg-white w-[70%] rounded-md relative overflow-y-auto p-10 flex flex-col "
        >
          {bars.map((bar: any) => (
            <motion.div
              key={bar.id}
              initial={{
                width: 0,
              }}
              animate={{
                width: bar.width + "%",
                opacity: 1,
              }}
              transition={{
                duration: 1,
              }}
              className="bg-gray-100 h-12 rounded-lg mb-4"
            ></motion.div>
          ))}
        </motion.div>
        <div className="h-full bg-white w-[30%] rounded-md flex flex-col justify-end">
          <div className="w-[90%] mx-auto h-12 bg-gray-50 mb-10 rounded-md" />
        </div>
      </div>
    </div>
  );
};

export const DummyBars = () => {
  const [bars, setBars] = useState<any>([]);

  useEffect(() => {
    createRandomBars();
  }, []);
  const createRandomBars = () => {
    const newBars: any = [];
    for (let i = 0; i < 15; i++) {
      newBars.push({
        id: i,
        value: Math.floor(Math.random() * 100),
        color: `hsl(${Math.floor(Math.random() * 360)}, 100%, 50%)`,
        width: Math.floor(Math.random() * (80 - 30 + 1) + 30),
        key: uuidv4(),
        // between 10 to 20px
        height: Math.floor(Math.random() * (40 - 30 + 1) + 30),
      });
    }
    setBars(newBars);
  };
  const listItem = {
    hidden: { opacity: 0, width: 0 },
    show: { opacity: 1, width: "inherit" },
  };

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="h-full bg-white w-full  rounded-md relative overflow-y-auto py-10 flex flex-col "
    >
      {bars.map((bar: any) => (
        <motion.div
          key={bar.key}

          initial={{
            width: bar.width + "%",
          }}
          animate={{
            width: "100%",
            opacity: 1,
            transition: {
              // random between 3 and 5
              duration: Math.floor(Math.random() * (5 - 3 + 1) + 3),
              repeat: Infinity,
              repeatType: "reverse",
            },
            // repeat animation of opacity 0.4 to 1
          }}
          transition={{
            duration: 1,
          }}
          style={{
            height: bar.height,
          }}
          className="bg-gray-100 rounded-lg mb-4"
        ></motion.div>
      ))}
    </motion.div>
  );
};
